export interface AdminUser {
    name: string;
    email: string;
    phoneNumber: string;
    password: string;

    permissions: string[];
    adminType: string;

    coordinators: AccessGrant[];
    tmsPersons: AccessGrant[];
    teachers: AccessGrant[];
    supportPersons: AccessGrant[];
    mediaPersons: AccessGrant[];

    showAllCoordinators: boolean;
    showAllTMSPersons: boolean;
    showAllTeachers: boolean;
    showAllSupportPersons: boolean;
    showAllMediaPersons: boolean;

    dotPermissions: string[];
    hrPermissions: string[];
    bizPermissions: string[];
    instructorTabButtons: string[];
    tmsPermissions:string[];
    employeeRef:string|null;
    coursesPermissions:string[]
}

export interface AccessGrant {
    id: string;
    name: string;
    accessType: ACCESS_TYPE;
}

export enum ACCESS_TYPE {
    FULL = "full",
    VIEW = "view",
}
